import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ListItemText, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { FocusableSpan } from '~/modules/common/components/FocusableSpan';

const useStyles = makeStyles(theme => ({
  primary: {
    fontWeight: 'bold',
    fontSize: theme.typography.body2.fontSize,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.text.primary,
    cursor: 'pointer'
  },
  secondary: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  }
}));

const useTaskCodeStyles = makeStyles(theme => ({
  taskCode: {
    marginLeft: theme.spacing(1)
  }
}));

const GanttTaskName2 = ({ task, ariaLabel }) => {
  const classes = useStyles();
  const taskCodeClasses = useTaskCodeStyles();

  const primary = useMemo(
    () => (
      <>
        <FocusableSpan className="gantt_task_name" ariaLabel={ariaLabel}>
          {task.text}
        </FocusableSpan>
        <FocusableSpan
          className={classNames(classes.secondary, taskCodeClasses.taskCode)}
        >
          {task.code}
        </FocusableSpan>
      </>
    ),
    [
      ariaLabel,
      classes.secondary,
      taskCodeClasses.taskCode,
      task.code,
      task.text
    ]
  );

  return (
    <ListItemText
      classes={classes}
      primary={primary}
      secondary={
        task.$level === 0 ? null : task?.assignedRole?.displayText || '–'
      }
    />
  );
};

GanttTaskName2.propTypes = {
  task: PropTypes.shape({
    text: PropTypes.string.isRequired,
    code: PropTypes.string,
    assignedRole: PropTypes.shape({
      displayText: PropTypes.string
    }),
    $level: PropTypes.number
  }).isRequired,
  ariaLabel: PropTypes.string
};

export default GanttTaskName2;
